const couponsDictES = {
  specialCustomerRegisterCoupons: "Cupones de Crédito",
  generateCoupon: "Cupón de invitación",
  extracoinAmount: "Cantidad de crédito Extracredit",
  unexpectedErrorWhileGeneratingCoupon: "Error inesperado al generar cupón de crédito.",
  currency: "Moneda",
  used: "Usado",
  notUsed: "No usado",
  couponGenerated: "Has generado un nuevo cupón de crédito con éxito!",
  couponCanceled: "Ha cancelado la operación para generar un nuevo cupón de crédito.",
  areYouSureCoupon:
    "Está seguro de que desea generar un nuevo cupón de crédito? El importe se debitará de su saldo Extracredit.",
  confirmYourAction: "Confirma tu acción",
  confirm: "Confirmar",
  usedBy: "Usado por",
  generatedCoupon: "Cupón generado",
  inviteCouponDialogTitle: "Creación del cupón de invitación",
  inviteCouponDialogSubtitle: "Envía créditos extra de bienvenida.",
  inviteCouponSectionBalance: "Saldo Extracredit",
  inviteCouponSectionData: "Datos del cupón",
  inviteCouponAmountLabel: "Introduce el importe",
  inviteCouponAmountTooltip: "Importe debitado de tu saldo Extracredit al crear el cupón.",
  inviteCouponAmountHint: "Usa hasta {balance} ECR",
  inviteCouponBelowMinBalance: "El saldo mínimo para crear un cupón es {min} ECR.",
  inviteCouponCreating: "Espera mientras creamos el cupón.",
  inviteCouponCancel: "Cancelar",
  inviteCouponCreate: "Crear cupón",
  inviteCouponSuccessTitle: "Cupón creado",
  inviteCouponSuccessMeta: "Éxito • {dateTime}",
  inviteCouponYouUsed: "Has usado",
  inviteCouponCodeSection: "Código del cupón",
  inviteCouponShareHint:
    "Comparte este código con tu invitado. Recibirá {couponValue} en ECR al registrarse. Este código solo se puede usar una vez.",
  inviteCouponFinish: "Finalizar",
  inviteCouponErrorGeneric: "No se pudo crear el cupón. Inténtalo de nuevo.",
};

export default couponsDictES;
